import {
    apiRequest,
    rekapSyncPresensi,
    rekapExport
} from "../../../../../services/adapters/kepegawaian/rekapAbsensiService"

class IndexRepository {

    fetchSync = async (query) => {
        return await apiRequest("get", rekapSyncPresensi, {
            params: query
        }, true)
    }
    fetchExport = async (query) => {
        return await apiRequest("get", rekapExport, {
            params: query
        }, true)
    }
}

export default IndexRepository